import React, { Fragment, useState, useEffect } from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ListItemText from "@material-ui/core/ListItemText";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import { FilterList } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
    maxWidth: 500,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  iconButtons: {
    marginRight: theme.spacing(1),

  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 450,
    },
  },
};

const BranchFilter = ({ fluids, statuses, tags, setFilters, DTE_range, filtersInfo }) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [fluidName, setFluidName] = useState([]);
  const [statusName, setStatusName] = useState([]);
  const [tagName, setTagName] = useState([]);
  const [ullage, setUllage] = useState([0, 100]);
  const [DTE, setDTE] = useState("noFilter");
  const [showSensorWarning, setShowSensorWarning] = useState(0);
  const handleFluidChange = (event) => setFluidName(event.target.value);
  const handleStatusChange = (event) => setStatusName(event.target.value);
  const handleDteChange = (event) => setDTE(event.target.value);
  const handleTagChange = (event) => setTagName(event.target.value);
  const handleUllageRangeChange = (event, newValue) => setUllage(newValue);


  useEffect(() => {
    if (filtersInfo.showSensorWarning){
      setShowSensorWarning(filtersInfo.showSensorWarning);
    } else {
      setShowSensorWarning(0);
    }
  }, [filtersInfo]);

  const handleApply = () => {
    setOpen(false);
    setFilters({ 'fluidName': fluidName, 'statusName': statusName, 'tagName': tagName, 'ullageRange': ullage, 'DTE': DTE, 'showSensorWarning': showSensorWarning }, true);
  };

  const handleReset = () => {
    setOpen(false);
    setFluidName([]);
    setStatusName([]);
    setTagName([]);
    setUllage([0, 100]);
    setDTE("noFilter");
    setShowSensorWarning(0);
    setFilters({ 'fluidName': [], 'statusName': [], 'tagName': [], 'ullageRange': [0, 100], 'DTE': "noFilter", "showSensorWarning": 0 }, true);
  };
  
  return (
    <Fragment>
      {true && <Tooltip title={t("filters")}>
        <IconButton
          aria-haspopup='true'
          onClick={handleClickOpen}
          color='inherit'
          className={classes.iconButtons}
        >
          <FilterList />
        </IconButton>
      </Tooltip>}

      {false && <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {t("filter")}
      </Button>}

      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-title"
      >
        <DialogTitle id="dialog-title">{t("filter")}</DialogTitle>
        <DialogContent>
          <form className={classes.form} noValidate>
            <div className="form">
              <div className="input-container">
                <FormControl className={classes.formControl}>
                  <InputLabel id="fluids-mutiple-checkbox-label">{t("fluid")}</InputLabel>
                  <Select
                    labelId="fluid-mutiple-checkbox-label"
                    id="fluid-mutiple-checkbox"
                    multiple
                    value={fluidName}
                    onChange={handleFluidChange}
                    input={<Input />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                  >
                    {fluids.map((fluid) => (
                      <MenuItem key={fluid.id} value={fluid.name}>
                        <Checkbox checked={fluidName.indexOf(fluid.name) > -1} />
                        <ListItemText primary={fluid.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="input-container">
                <FormControl className={classes.formControl}>
                  <InputLabel id="status-mutiple-checkbox-label">{t("status")}</InputLabel>
                  <Select
                    labelId="status-mutiple-checkbox-label"
                    id="status-mutiple-checkbox"
                    multiple
                    value={statusName}
                    onChange={handleStatusChange}
                    input={<Input />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                  >
                    {statuses.map((status) => (
                      <MenuItem key={status} value={status}>
                        <Checkbox checked={statusName.indexOf(status) > -1} />
                        <ListItemText primary={status} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="input-container">
                <FormControl className={classes.formControl}>
                  <InputLabel id="dte-dropdown-label">{t("daysUntilEmpty")}</InputLabel>
                  <Select
                    labelId="dte-dropdown-label"
                    id="dte-dropdown"
                    value={DTE}
                    onChange={handleDteChange}
                    input={<Input />}
                    MenuProps={MenuProps}
                  >
                    {DTE_range.map((DTE_val) => (
                      <MenuItem key={DTE_val} value={DTE_val}>
                        <ListItemText primary={t(DTE_val)} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="input-container">
                <FormControl className={classes.formControl}>
                  <Typography id="range-slider" gutterBottom>
                    {t("ullagePercent")}
                  </Typography>
                  <Slider
                    value={ullage}
                    onChange={handleUllageRangeChange}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                  />
                </FormControl>
              </div>
              <div className="input-container">
                <FormControl className={classes.formControl}>
                  <InputLabel id="tag-mutiple-checkbox-label">{t("Tag")}</InputLabel>
                  <Select
                    labelId="tag-mutiple-checkbox-label"
                    id="tag-mutiple-checkbox"
                    multiple
                    value={tagName}
                    onChange={handleTagChange}
                    input={<Input />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                  >
                    {tags.map((tag) => (
                      <MenuItem key={tag} value={tag}>
                        <Checkbox checked={tagName.indexOf(tag) > -1} />
                        <ListItemText primary={tag} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="input-container">
                <FormControlLabel className={classes.formControl}
                  label={t("showSensorWarning")}
                  control={
                    <Checkbox
                        checked={showSensorWarning}
                        onChange={(event)=>{setShowSensorWarning(event.target.checked ? 1 : 0)}}
                        name="show_sensor_warning"
                        color="primary"
                    />
                  }
                />
              </div>
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReset} color="primary">
            {t("Reset")}
          </Button>
          <Button onClick={handleClose} color="primary">
            {t("Cancel")}
          </Button>
          <Button onClick={handleApply} variant="contained" color="primary">
            {t("Apply")}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default BranchFilter;
